/* eslint-disable react/jsx-filename-extension */
import {
  Box,
  Button,
  makeStyles,
  TextField,
  Typography,
} from '@material-ui/core';
import AgentChatManager from '@src/logic/agentchatmanager';
import { selectB2ChatJSIntegrations } from '@src/reducers/integrations';
import { integrationAppsSelector } from '@src/selectors/integrationApps';
import WidgetContainer from '@src/widget/WidgetContainer';
import { useEffect } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { SideMenuTabs } from '../AgentConsole/SideMenu/constants';
import ContactViewer from '../ContactViewer';
import ShopifyViewer from '../ShopifyViewer';
import { WsCatalogueMenuView } from '../WSCatalogue/WsCatalogueMenuView';
import ChatbotHistoryViewer from './ChatbotHistoryViewer';

const useStyles = makeStyles(theme => ({
  title: {
    display: 'flex',
    justifyContent: 'center',
    padding: '16px',
    textTransform: 'capitalize',
    color: theme.palette.text.primary,
    fontSize: '16px',
    fontWeight: 700,
  },
}));

const ChatContextMenu = ({ chatContextMenu, chatHistory, activeChat }) => {
  const activeIndex = chatContextMenu.selectedOption;
  const curChatbotHistory = chatHistory ? chatHistory.chatbotHistory : null;

  const { title } = useStyles();

  useEffect(() => {
    if (activeChat?.id) {
      AgentChatManager.loadChatBotHistory(
        activeChat.contact.cmaId,
        activeChat.viaBotAccount,
        activeChat.provider
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeChat?.id]);

  const integrations = useSelector(selectB2ChatJSIntegrations);
  const apps = useSelector(integrationAppsSelector);

  return (
    <Box display="flex" flexDirection="column" height="100%">
      {activeIndex === SideMenuTabs.Contact && (
        <Box display="flex" flexDirection="column" flex={1} position="relative" overflow="hidden">
          <Box className={title}>
            <FormattedMessage id="ChatContextMenu.contactInfoTabLbl" />
          </Box>
          <ContactViewer />
        </Box>
      )}
      {activeIndex === SideMenuTabs.Shopify && <ShopifyViewer />}
      {curChatbotHistory && activeIndex === SideMenuTabs.ChatBot && (
        <>
          <Box className={title}>
            <FormattedMessage id="ChatContextMenu.chatbotHistoryTabLbl" />
          </Box>
          <ChatbotHistoryViewer jsonChatbotHistory={curChatbotHistory} />
        </>
      )}
      {activeIndex === SideMenuTabs.Fluentlab && (
        <>
          <Box className={title}>
            <Typography>Base de conocimiento</Typography>
          </Box>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gridGap: '10px',
              padding: '10px 16px',
              flexDirection: 'column',
            }}
          >
            <Box sx={{ width: '100%' }}>
              <Typography style={{ fontWeight: '500', fontSize: '12px' }}>
                ¿Cómo podemos ayudarte?
              </Typography>
              <TextField
                id="standard-multiline-static"
                multiline
                rows={3}
                fullWidth
              />
            </Box>
            <Button variant="contained" color="primary" size="medium">
              Buscar
            </Button>
          </Box>
        </>
      )}
      {activeIndex === SideMenuTabs.WsCatalogue && (
        <WsCatalogueMenuView titleStyleClassName={title} />
      )}
      {integrations.map(
        item =>
          activeIndex === item.id && (
            <WidgetContainer
              key={item.id}
              source={item.config.url}
              widgetName={item.config.name}
            />
          )
      )}

      {apps.map(
        item =>
          activeIndex === item.id && (
            <WidgetContainer
              key={item.id}
              source={item.url}
              widgetName={item.name}
            />
          )
      )}

      {activeIndex === 'widget-dev' && (
        <WidgetContainer devMode source="" widgetName="widget-dev" />
      )}
    </Box>
  );
};

export default injectIntl(ChatContextMenu);
